import React from 'react'

function TenderTextVRIDN() {
  return (
    <embed src="\pdfs\EAT1.7.1_VRI-DN_Volume_flow_controller_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextVRIDN